export const kyou = () => {
  if (document.getElementById("kyou")) {
    const kyouSlide = new Swiper("#kyouSlide", {
      spaceBetween: 80,
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: "auto",
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1800,
      navigation: {
        nextEl: "#kyouSlidePrev",
        prevEl: "#kyouSlideNext",
      },
    });
  }
};
